export const customers = state => state.customers
export const customer = state => state.customer
